// extracted by mini-css-extract-plugin
export default {"confirmation":"SettingsSubmitConfirmation-module__confirmation--2X7u+","fadeOut":"SettingsSubmitConfirmation-module__fadeOut--Yk-Tc"};